import type { CustomizablePdfDeal } from '@makemydeal/dr-platform-types';

export const NO_DEALS: CustomizablePdfDeal[] = [];
